import { useCallback, useSyncExternalStore } from 'react'

/**
 * Volgt een CSS-mediaquery vanuit React. Bewust geen effect met state: die zet de eerste
 * render altijd op de verkeerde waarde en laat een paneel dus even in de andere vorm zien.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    [query],
  )

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Onder de `sm`-breakpoint van Tailwind: telefoonformaat. */
export function useIsCompact(): boolean {
  return useMediaQuery('(max-width: 639px)')
}
